import { PrePlacementDocumentType } from '@duke-hq/svc-api-db';
import { t } from '@lingui/core/macro';

export function getDocumentTypeLabel(): Record<PrePlacementDocumentType, string> {
  return {
    WORKING_WITH_CHILDREN_CHECK: t`Working with Children Check`,
    POLICE_CHECK: t`Police Check`,
    RESUME: t`Resume`,
    IMMUNISATION_RECORD: t`Immunisation Record`,
    WORKING_WITH_VULNERABLE_PEOPLE_CHECK: t`Working with Vulnerable People Check`,
    NDIS_WORKER_SCREENING_CHECK: t`NDIS Worker Screening Check`,
  };
}
